import type { RegisteredComponent } from "@builder.io/sdk-react";

import { DEFAULT_CHIPS } from "~/hec/components/spender-chip-row/chips";
import { SpenderChipsSection } from "~/hec/components/spender-page/spender-sections";
import { SPENDER_CHIP_ROW_BLOCK_NAME } from "~/routes/fsastore-spender/spender-page";

/**
 * COM-261: the chip row as an authored block; it filters the grid through `?cat=`.
 * The `chips` input is read by the server (loader data), never from props here,
 * so the row and the grid always validate `?cat=` against the same list.
 */
const SpenderChipRowBlock = ({
  attributes,
}: {
  attributes?: Record<string, unknown>;
  chips?: unknown;
}) => (
  <div data-testid="spender-chip-row-block-root" {...attributes}>
    <SpenderChipsSection />
  </div>
);

export const SpenderChipRowDefinition = {
  component: SpenderChipRowBlock,
  name: SPENDER_CHIP_ROW_BLOCK_NAME,
  friendlyName: "FSA Spender chip row (FSA only)",
  noWrap: true,
  canHaveChildren: false,
  inputs: [
    {
      name: "chips",
      type: "list",
      defaultValue: DEFAULT_CHIPS.map(({ id }) => ({ categoryId: id })),
      subFields: [
        {
          name: "categoryId",
          type: "string",
          required: true,
          helperText:
            "Category / CIO group id (e.g. personal-care). Hidden unless the main menu shows it to this shopper (Best Sellers and Bundles always show).",
        },
        {
          name: "label",
          type: "string",
          helperText: "Optional. Empty: the category's menu name.",
        },
        {
          name: "image",
          friendlyName: "Icon",
          type: "file",
          allowedFileTypes: ["jpeg", "jpg", "png", "svg", "webp"],
          helperText:
            "Optional. Empty: the Category Icon of the category-enrichment entry whose Category Short Name is this category id (the PLP pills' icon), if any; else the chip is text only.",
        },
      ],
      helperText:
        "Chips in order. The first chip is the default (it has no ?cat= in the URL). Empty: the 7 standard chips. Save, then reload the preview.",
    },
  ],
} satisfies RegisteredComponent;

export default SpenderChipRowBlock;
